import { render, staticRenderFns } from "./QiangLiBoxLabelDialog.vue?vue&type=template&id=71ddd2b9&scoped=true"
import script from "./QiangLiBoxLabelDialog.vue?vue&type=script&lang=js"
export * from "./QiangLiBoxLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./QiangLiBoxLabelDialog.vue?vue&type=style&index=0&id=71ddd2b9&prod&scoped=true&lang=css"
import style1 from "./QiangLiBoxLabelDialog.vue?vue&type=style&index=1&id=71ddd2b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ddd2b9",
  null
  
)

export default component.exports